<h5 class="plan-name">
  {{planLabel}}
</h5>
<a class="choose-plan-button"
   color="warn"
   mat-flat-button
   (click)="choosePlan(plan, $event)">
  Select plan
</a>
